import { RoutePath } from '@constants/routes';

export const PATH_MAP = {
    [RoutePath.Login]: 'login',
    [RoutePath.Signup]: 'signup',
    [RoutePath.ResetPassword]: 'resetPassword',
    [RoutePath.ForgotPassword]: 'forgotPassword',
    [RoutePath.VerifyEmail]: 'verifyEmail',
    [RoutePath.Error]: 'error',
    // INFO: In AppLayout paths
    [RoutePath.Home]: 'home',
    [RoutePath.Surveys]: 'surveys',
    [RoutePath.SurveysResponses]: 'responses',
    [RoutePath.SurveysTemplates]: 'templates',
    [RoutePath.SurveysAnalyticsConversion]: 'analytics',
    [RoutePath.SurveysAnalyticsResponses]: 'analytics',
    [RoutePath.SurveysAnalyticsSurveyInsights]: 'analytics',
    [RoutePath.ReviewsManage]: 'reviewsManage',
    [RoutePath.ReviewsAutomationAutoReplies]: 'reviewsAutomation',
    [RoutePath.ReviewsAutomationTemplates]: 'reviewsAutomation',
    [RoutePath.ReviewsWidgets]: 'reviewsWidgets',
    [RoutePath.ReviewsAnalyticsReviews]: 'analytics',
    [RoutePath.ReviewsAnalyticsOperationalInsights]: 'analytics',
    [RoutePath.ReviewsAnalyticsKeywords]: 'analytics',
    [RoutePath.MessagingInbox]: 'messagingInbox',
    [RoutePath.MessagingPulseAIKnowledgeBase]: 'pulseAI',
    [RoutePath.MessagingPulseAIAgents]: 'pulseAI',
    [RoutePath.MessagingAnalytics]: 'analytics',
    [RoutePath.Microsites]: 'microsites',
    [RoutePath.Menus]: 'menus',
    [RoutePath.Forms]: 'forms',
    [RoutePath.AccountSettingsProfile]: 'settings',
    [RoutePath.AccountSettingsGeneral]: 'settings',
    [RoutePath.AccountSettingsBilling]: 'settings',
    [RoutePath.AccountSettingsChannels]: 'settings',
    [RoutePath.AccountSettingsUsers]: 'settings',
    [RoutePath.AccountSettingsIntegrations]: 'settings',
    [RoutePath.AccountSettingsBrands]: 'settings',
    [RoutePath.AccountSettingsTeams]: 'settings',
    [RoutePath.Onboarding]: 'onboarding',
    [RoutePath.SocialPosts]: 'socialPosts',
    [RoutePath.SocialAnalytics]: 'analytics',
    //'/orders': 'ordersIfood',
    [RoutePath.Campaigns]: 'campaigns',
    [RoutePath.CampaignsAutomated]: 'campaignsAutomated',
    [RoutePath.CampaignsOneTime]: 'campaignsOneTime',
    [RoutePath.CampaignsLibrary]: 'campaignsLibrary',
    [RoutePath.Contacts]: 'contacts',
    [RoutePath.LocationsManage]: 'locationsManage',
    [RoutePath.LocationsProfiles]: 'locationsProfiles',
    [RoutePath.LocationsMedia]: 'locationsMedia',
    [RoutePath.LocationsVisibilityScanner]: 'visibilityScanner',
    [RoutePath.LocationsAnalytics]: 'locationsAnalytics',
    [RoutePath.LocationsAnalyticsPerformance]: 'locationsAnalytics',
    [RoutePath.Locations]: 'locationsManage',
    [RoutePath.Presence]: 'locationsProfiles',
    [RoutePath.PresenceProfiles]: 'locationsProfiles',
    [RoutePath.PresenceMedia]: 'locationsMedia',
    [RoutePath.PresenceAnalytics]: 'locationsAnalytics',
    [RoutePath.Coupons]: 'coupons',
};
